import styled from "styled-components";

const Resources = () => {
  return <div>resources</div>;
};

export default Resources;
